import { useState } from "react";
import { useNavigate } from "react-router-dom";
import DeleteModal from "../../../../common/DeleteModal";
import { useSelector } from "react-redux";
import editIcon from "../../../../../images/icons/edit.svg";
import trashIcon from "../../../../../images/icons/delete.svg";
import ParkingSlotsService from "../../../../../services/ParkingSlotsService";
import { usePermissions } from "../../../../common/permissions";

const CardItem = ({ item, index, setShouldUpdate, setItem, setAddModal }) => {
	const [deleteModal, setDeleteModal] = useState(false);
	const parkingSlotsService = new ParkingSlotsService();
	const Auth = useSelector((state) => state.auth?.auth);
	const { canEdit, canDelete } = usePermissions();
	const lang = useSelector((state) => state.auth?.lang);

	return (
		<tr key={index}>
			<td className="text-wrap-mode">
				{lang === "en" ? item?.name_en : item?.name_ar}
			</td>
			<td>{lang === "en" ? item?.zone?.name_en : item?.zone?.name_ar}</td>
			<td>{item?.floor_number}</td>
			<td>{item?.note || "-"}</td>
			<td>
				<div className="d-flex" style={{ gap: "20px" }}>
					{canEdit("parking_slot") && (
						<img
							src={editIcon}
							onClick={() => {
								setItem(item);
								setAddModal(true);
							}}
							className="cursor-pointer"
							alt="edit"
							width={24}
						/>
					)}
					{canDelete("parking_slot") && (
						<img
							src={trashIcon}
							onClick={() => setDeleteModal(true)}
							className="cursor-pointer"
							alt="trash"
							width={24}
						/>
					)}
				</div>
			</td>
			{deleteModal && (
				<DeleteModal
					open={deleteModal}
					titleMsg={lang === "en" ? item?.name_en : item?.name_ar}
					deletedItem={item}
					modelService={parkingSlotsService}
					setShouldUpdate={setShouldUpdate}
					onCloseModal={setDeleteModal}
				/>
			)}
		</tr>
	);
};
export default CardItem;
